import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel" ]

  get frame() {
    return this.element.querySelector("turbo-frame")
  }

  connect() {
    if (new URLSearchParams(window.location.search).get("modal") === "open") {
      this.open()
    }

    this.modalCloseHandler = () => this.close()
    this.element.addEventListener("modal:close", this.modalCloseHandler)
    
    this.observer = new MutationObserver(() => {
      const frame = this.frame
      if (frame && frame.innerHTML.trim() === "") {
        this.close()
      }
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.element.removeEventListener("modal:close", this.modalCloseHandler)
    this.observer?.disconnect()
  }

  open() {
    if (this.frame && this.frame.innerHTML.trim() === "") return;
    this.element.classList.remove("hidden")
    this.element.classList.add("flex")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (event && event.type && this.element.dataset.preventClose === "true") {
      event.preventDefault();
      return;
    }
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    document.body.classList.remove("overflow-hidden")

    const frame = this.element.querySelector("turbo-frame")
    if (frame) {
      frame.removeAttribute("src")
      if (frame.innerHTML.trim() !== "") {
        setTimeout(() => {
          frame.innerHTML = ""
        }, 0)
      }
    }
  }

  closeOnBackdrop(event) {
    if (this.element.dataset.preventClose === "true") return;
    if (event.target === this.element) {
      this.close()
    }
  }
}
